
import './App.css';
import NicDetails from "./pages/NicDetails";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import DrivingLicense from './pages/DrivingLicense';
import PersonalDetails from './pages/PersonalDetails';
import ProfilePicture from './pages/ProfilePicture';
import EmergencyContact from './pages/EmergencyContact';
import VehicleDetails from './pages/VehicleDetails';
import VehicleLog from './pages/VehicleLog';
import MotorcycleInsurance from './pages/MotorcycleInsurance';
import RequirementList from "./pages/Components";
import InvalidToken from "./pages/Components/invalidToken";
import Completed from "./pages/Components/completed";
import DisplayProfileList from "./pages/Components/listProfiles";
import { useEffect } from "react";
import { setOnboardingSessionToken } from "./utils/util";

const TokenInitializer = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      setOnboardingSessionToken(token);
    }
  }, [token]);

  return null;
};


function App() {
  return (
 <> 

<BrowserRouter>
    <TokenInitializer />
    <Routes>
      <Route path='nic' element={<NicDetails />}>
      </Route>
      <Route path='driving-license' element={<DrivingLicense />}>
      </Route>
      <Route path='profile-picture' element={<ProfilePicture />}>
      </Route>
      <Route path='personal-details' element={<PersonalDetails />}>
      </Route>
      <Route path='emergency-contact' element={<EmergencyContact />}>
      </Route>
      <Route path='vehicle-details' element={<VehicleDetails />}>
      </Route>
      <Route path='vehicle-log' element={<VehicleLog />}>
      </Route>
      <Route path='motorcyce-insurance' element={<MotorcycleInsurance />}>
      </Route>
      <Route path='/old' element={<Home />}>
      </Route>
      <Route path='/sessionExpired' element={<InvalidToken />}>
      </Route>
      <Route path='/completed' element={<Completed />}>
      </Route>
      <Route path='/documents' element={<RequirementList />}>
      </Route>
      <Route path='/' element={<DisplayProfileList/>}>
      </Route>
      
    </Routes>
    
</BrowserRouter>



    </>
  );
}

export default App;
